/* ACCORDION (About Page) */

export function initAccordion() {
  document.querySelectorAll('.accordion-header').forEach(btn => {
    btn.addEventListener('click', () => {
      const item    = btn.closest('.accordion-item');
      const content = item && item.querySelector('.accordion-content');
      const inner   = item && item.querySelector('.accordion-inner');
      if (!item || !content) return;

      const isOpen = item.classList.contains('active');

      // Close others
      document.querySelectorAll('.accordion-item.active').forEach(open => {
        if (open === item) return;
        open.classList.remove('active');
        const c = open.querySelector('.accordion-content');
        if (c) { c.style.height = '0'; c.style.opacity = '0'; }
      });

      if (isOpen) {
        item.classList.remove('active');
        content.style.height  = '0';
        content.style.opacity = '0';
      } else {
        item.classList.add('active');
        content.style.height  = inner ? (inner.offsetHeight + 'px') : 'auto';
        content.style.opacity = '1';
      }
    });
  });
}


